import { setBaseUrl } from '@sit/client-shared';

let backendOrigin = import.meta.env.VITE_APP_API_URL || '';

export function updateBackendOrigin(origin: string): void {
  backendOrigin = origin;
  setBaseUrl(origin);
}

const VITE_APP_ADMIN_URL = import.meta.env.VITE_APP_ADMIN_URL || 'https://admin.time.sage.com';
const VITE_APP_DIMENSION_SYNC_TIMEOUT = import.meta.env.VITE_APP_DIMENSION_SYNC_TIMEOUT || '5';
const VITE_APP_INTACCT_WEB_IA_ACCT = import.meta.env.VITE_APP_INTACCT_WEB_IA_ACCT || 'https://www.intacct.com/ia/acct';
const VITE_APP_IS_PRODUCTION = import.meta.env.VITE_APP_IS_PRODUCTION;
const VITE_APP_IS_QA2 = import.meta.env.VITE_APP_ENV === 'qa2';
const VITE_APP_MINUTES_TO_REFRESH_CPTI = import.meta.env.VITE_APP_MINUTES_TO_REFRESH_CPTI || '5';
const VITE_APP_ROW_CHECKS_MIN = import.meta.env.VITE_APP_ROW_CHECKS_MIN || '2';
const VITE_APP_SUPPORTED_BROWSERS_LINK = import.meta.env.VITE_APP_SUPPORTED_BROWSERS_LINK;
const VITE_APP_SHOW_LEAVE = import.meta.env.VITE_APP_SHOW_LEAVE === 'true';
const VITE_APP_AWS_MAPS_KEY = import.meta.env.VITE_APP_AWS_MAPS_KEY || '';
const VITE_APP_AWS_MAPS_REGION = import.meta.env.VITE_APP_AWS_MAPS_REGION || 'us-east-1';
const VITE_APP_AWS_MAPS_STYLE = import.meta.env.VITE_APP_AWS_MAPS_STYLE || 'Standard';

export const config = {
  get apiUrl() {
    return backendOrigin;
  },
  get notificationsUrl() {
    // this.apiUrl has `/api` prefixed already.
    return `${this.apiUrl}/ws/notifications`;
  },
  isProduction: VITE_APP_IS_PRODUCTION !== undefined,
  isCypress: import.meta.env.VITE_APP_ENV === 'cypress',
  get loginEnabled() {
    // On Oct 10th, 2025, we will drop support with standalone SIT web.
    return !this.isProduction || this.isCypress;
  },
  get joinUsModalEnabled() {
    // On Oct 10th, 2025, we will drop support with standalone SIT web.
    const isAmplify = typeof window !== 'undefined' && window.location.hostname.endsWith('.amplifyapp.com');
    return (this.isProduction || VITE_APP_IS_QA2) && !this.isCypress && !isAmplify;
  },
  VITE_APP_ADMIN_URL,
  VITE_APP_DIMENSION_SYNC_TIMEOUT: Number.parseInt(VITE_APP_DIMENSION_SYNC_TIMEOUT, 10),
  VITE_APP_INTACCT_WEB_IA_ACCT,
  VITE_APP_MINUTES_TO_REFRESH_CPTI: Number.parseInt(VITE_APP_MINUTES_TO_REFRESH_CPTI, 10),
  VITE_APP_ROW_CHECKS_MIN: Number.parseInt(VITE_APP_ROW_CHECKS_MIN, 10),
  VITE_APP_SUPPORTED_BROWSERS_LINK,
  VITE_APP_SHOW_LEAVE,
  VITE_APP_AWS_MAPS_KEY,
  VITE_APP_AWS_MAPS_REGION,
  VITE_APP_AWS_MAPS_STYLE,
} as const;

export const intacctUrls = {
  login: `${VITE_APP_INTACCT_WEB_IA_ACCT}/login.phtml`,
  resetPassword: `${VITE_APP_INTACCT_WEB_IA_ACCT}/resetpassword.phtml`,
  ur: `${VITE_APP_INTACCT_WEB_IA_ACCT}/ur.phtml`,
  timeHomepage: 'https://www.sage.com/en-gb/sage-business-cloud/intacct/product-capabilities/extended-capabilities/timesheet-management/',
};
